<template>
  <button
    class="button-round button-no-active p-0"
    :class="this.class"
    @click="click"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "IconButton",
  props: {
    icon: Object,
    class: String,
  },
  emits: ["click"],
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>
